// extracted by mini-css-extract-plugin
export default {"container":"BrowserNotSupported_container__MaA6t","content":"BrowserNotSupported_content__tJZsy","img":"BrowserNotSupported_img__5RE3y"};